import { getCookie } from '../utils/domUtils';
import { getPageName } from '../utils/pageName';

declare global {
  interface Window {
    fetchFullstory: Function;
    fetchFacebook: Function;
    fetchLinkedin: Function;
    fetchTwitter: Function;
    fbq: any | undefined;
  }
}

export function startProviders() {
  try {
    const cookieString: string = getCookie('cookies_policy');
    if (cookieString) {
      window.fetchFullstory();
      window.fetchFacebook();
      window.fetchLinkedin();
      window.fetchTwitter();
    }
    if (window.fbq && getPageName() === 'Signup') {
      /* 
        Redundancy of this event with SignUpLayout
        component does not communicate with cookie acceptance
        triggers pixel if cookie is accepted on the page
      */
      window.fbq('track', 'ViewContent');
    }
  } catch (error) {
    console.log(error);
  }
}
